import { useMutation, useQuery } from '@tanstack/react-query';
import { axiosInstance, VideoDetailsType } from '../../utils';
import { AIMedia } from '../../@types';

type Payload = {
  creationId: string;
};

const getTalkingFaceVideoById = async (payload: Payload): Promise<VideoDetailsType> => {
  const res = await axiosInstance.post('/api/videos/get-video', payload);
  return res.data;
};

export const useGetTalkingFaceVideoById = (payload: Payload) => {
  return useQuery(['fetchPublicAvatars', payload], () => getTalkingFaceVideoById(payload), {
    enabled: !!payload?.creationId,
  });
};
